/**
 * 新闻管理相关API接口
 */
import axios from '../axios'

const newsAPI = {
  // 新闻相关接口
  // 获取新闻列表
  getNewsList(params) {
    return axios({
      url: '/news',
      method: 'GET',
      params
    })
  },
  
  // 获取单个新闻详情
  getNews(id) {
    return axios({
      url: `/news/${id}`,
      method: 'GET'
    })
  },
  
  // 创建新闻
  createNews(data) {
    return axios({
      url: '/news',
      method: 'POST',
      data
    })
  },
  
  // 更新新闻
  updateNews(data) {
    return axios({
      url: `/news/${data.id}`,
      method: 'PUT',
      data
    })
  },
  
  // 删除新闻
  deleteNews(id) {
    return axios({
      url: `/news/${id}`,
      method: 'DELETE'
    })
  }
}

export default newsAPI